import { IPCliente } from "@/Service/URL";
import type { FormatData } from "@/Type/FormatData";
import axios from "axios";

//Obtener la ip-client
interface IpResponse {
  ip: string;
}

export const getIpCliente = async (): Promise<FormatData> => {
  try {
    const resp = await axios.get<IpResponse>(IPCliente);
    if (resp.data?.ip && resp.data.ip.trim() !== "") {
      return resp.data.ip;
    }
    return null; // si viene vacío
  } catch (error) {
    return null;
  }
};
